import { MeetingFormatType, ProxyEventType } from "src/store/proxyEvent/types";

export const PROXY_EVENT_LABEL: {
  [key in ProxyEventType]: string;
} = {
  annual_meeting: "Annual Meeting",
  special_meeting: "Special Meeting",
  contested_annual_meeting: "Contested Annual Meeting",
  contested_special_meeting: "Contested Special Meeting",
  information_statement: "Information Statement",
  summary_prospectus: "Summary Prospectus",
  "19_a_notice": "19(a) Notice",
  annual_report: "Annual Report",
  semi_annual_report: "Semi-Annual Report",
  consent_solicitation: "Consent Solicitation",
};

export const MEETING_FORMAT_LABEL: {
  [key in MeetingFormatType]: string;
} = {
  in_person: "In-Person",
  virtual: "Virtual",
  telephone: "Telephone",
  private: "Private",
};
